module.exports = __webpack_public_path__ + "img/selfie.63ecd808.png";